import {ChangeDetectionStrategy, Component, ElementRef, inject, viewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {mapParseItem} from '@brunata-angular/util';
import {z} from 'zod';
import {map, Observable, Subject, switchMap, tap} from 'rxjs';

@Component({
    selector: 'app-minenergi2',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    template: `
        @if (token$ | async; as token) {
            <form id="ssoForm" [action]="minEnergi2SSOUrl" method="post" target="_blank" #htmlForm>
                <input type="hidden" name="token" [value]="token" />
            </form>
        }
    `,
})
export class Minenergi2Component {
    private readonly htmlForm = viewChild<ElementRef<HTMLFormElement>>('htmlForm');

    private readonly http = inject(HttpClient);
    readonly minEnergi2SSOUrl = environment.minEnergi2SSOUrl;
    private readonly triggerSubject = new Subject<void>();

    readonly token$: Observable<string> = this.triggerSubject.pipe(
        switchMap(() => this.http.get(environment.onlineServiceUrl + '/user/minenergi2ssotoken')),
        mapParseItem(z.object({token: z.string()})),
        map(it => it.token),
        tap(() => setTimeout(() => this.htmlForm()?.nativeElement.submit(), 0)),
    );

    trigger(): void {
        this.triggerSubject.next();
    }
}
